import { useEffect } from 'react';

const FALLBACK_WHATSAPP_URL =
  'https://api.whatsapp.com/send/?phone=7039796526&text&type=phone_number&app_absent=0';

function WhatsAppHelpRedirect() {
  useEffect(() => {
    const url =
      process.env.REACT_APP_WHATSAPP_HELP_URL || FALLBACK_WHATSAPP_URL;
    window.location.replace(url);
  }, []);

  return null; // Nothing to render; redirect happens immediately
}

export default WhatsAppHelpRedirect;
